import { useSelector } from "react-redux";
import "./loader.css";
const Loader = () => {
  const loader_text = useSelector((state) => state.auth.loader_text);
  return (
    <>
      <div className="loader">
        <div className="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        {loader_text && (
          <p
            className="text-dark p-3"
            dangerouslySetInnerHTML={{
              __html: loader_text,
            }}
          ></p>
        )}
      </div>
    </>
  );
};

export default Loader;
